import { render, staticRenderFns } from "./VideoField.vue?vue&type=template&id=40bd4d38&"
import script from "./VideoField.vue?vue&type=script&lang=js&"
export * from "./VideoField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports